import React from "react";
import { useFormState } from "react-final-form";
import { Box, Tooltip } from "@material-ui/core";
import { RequiredClasses } from "./RequiredClasses";

const REQUIRED_CLASS_TRIGGER_TYPES = [
  "RequiredClassCompletion",
  "RequiredClassTaken",
];

export const RequiredClassesWrapper = () => {
  const { values } = useFormState();
  const isEnabled = REQUIRED_CLASS_TRIGGER_TYPES.includes(values?.triggerType);

  return (
    <Tooltip
      title={
        !isEnabled
          ? "Required classes can only be set for RequiredClassCompletion or RequiredClassTaken trigger types"
          : ""
      }
      placement="top"
    >
      <div>
        <Box
          style={{
            opacity: isEnabled ? 1 : 0.6,
            pointerEvents: isEnabled ? "auto" : "none",
            cursor: isEnabled ? "auto" : "not-allowed",
          }}
        >
          <RequiredClasses />
        </Box>
      </div>
    </Tooltip>
  );
};
